var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.25 42.0922L40.27 24.0322H45.725L53 45.8447H48.08L46.6575 41.0272H39.2425L37.635 45.8447H35.5025L35.5075 45.8572H28.74L26.785 39.2322H16.585L14.375 45.8572H8L18 15.8572H25.5L34.25 42.0922ZM18 33.3572H25.5L21.74 23.3572L18 33.3572ZM40.27 36.7572H45.725L42.99 29.4847L40.27 36.7572Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustIcon);
export default __webpack_public_path__ + "static/media/adjust-icon.4d253de84ad906d512509c83cf489b45.svg";
export { ForwardRef as ReactComponent };